import { motion } from 'framer-motion';
import React from 'react';

interface CardProps {
  children: React.ReactNode;
}

export const GrowMotionBox = (props: CardProps) => {
  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: 'auto', opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{
        height: { duration: 0.2, ease: 'easeInOut' },
        opacity: { duration: 0.4, ease: 'easeInOut' },
      }}
    >
      {props.children}
    </motion.div>
  );
};
